import {MutationTree} from 'vuex'
import { IServiceBook } from '../../models/service-book/service-book.model'
// @ts-ignore
import {IPatchServiceBook, IServiceBookSearchParams, IServiceBookState} from './service-book-state.store'
// @ts-ignore
import * as _ from './service-book-types.store'



export const mutations: MutationTree<IServiceBookState> = {
  [_.SERVICEBOOK_SET_SERVICEBOOKS]: (state: IServiceBookState, serviceBooks:IServiceBook[]) => {
    state.serviceBooks = serviceBooks
  },
  [_.SERVICEBOOK_SET_SERVICEBOOK]: (state: IServiceBookState, serviceBook:any) => {
    state.currentServiceBook = serviceBook
  },
  [_.SERVICEBOOK_SET_ISLOADING]: (state: IServiceBookState, isLoading:boolean) => {
    state.isLoading = isLoading
  },
  [_.SERVICEBOOK_SET_SEARCH_PARAMS]: (state: IServiceBookState, payload: IServiceBookSearchParams) => {
    console.log("SERVICEBOOK_SET_SEARCH_PARAMS = ",payload)
    state.serviceBookSearchParams = Object.assign({}, state.serviceBookSearchParams, {...payload})
  },

  [_.SERVICEBOOK_SET_COUNT]: (state: IServiceBookState, payload: {used:number, free:number}) => {
    state.free = payload.free
    state.used = payload.used
  },

  [_.SERVICEBOOK_SET_PATCH]: (state: IServiceBookState, payload: IPatchServiceBook) => {
    console.log("SERVICEBOOK_SET_PATCH = ",payload)
    state.patchServiceBook = Object.assign({}, state.patchServiceBook, {...payload})
  },

  [_.SERVICEBOOK_INIT_PATCH]: (state: IServiceBookState, payload: any) => {
    state.patchServiceBook = payload
  },
}



// WEBPACK FOOTER //
// ./src/store/service-book/service-book-mutations.store.ts